import { createSlice } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const initialState = {
  isLoading: false,
  openModalOrderDetail: false,
};

const slice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // OPEN MODAL

    onOpenModalReviewdetailPopup(state) {
      state.openModalReviewDetail = true;
    },

    // CLOSE MODAL

    onCloseModalForReviewDetail(state) {
      state.openModalReviewDetail = false;
    },

    onCloseModal(state) {
      state.openModalReviewDetail = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onCloseModal, onOpenModalReviewdetailPopup,  onCloseModalForReviewDetail } = slice.actions;
